/* eslint-disable react/jsx-one-expression-per-line */
import classNames from 'classnames'
import {
  newAppealState,
  stateCurrentAppeal,
} from 'feature/appeals/redux/appealFormCreateSelector'
import { useApproveOfferMutation } from 'feature/appeals/redux/appeals.api'
import { formatPriceInRubles } from 'helpers/formatPrice'
import { useActions, useAppSelector } from 'store/hooks'
import { LoaderInCentalPosition } from 'widget'

import { OfferDatesBlock } from '../OfferDatesBlock/OfferDatesBlock'
import { OfferPaymentDefaultInf } from '../OfferPaymentDefaultInf/OfferPaymentDefaultInf'
import { TOfferPayment } from '../types'

import style from './OfferPaymentDefault.module.scss'
import { useOfferPriceBlock } from '../OfferPriceBlock/useOfferPriceBlock'

// информация об оплате КП
export function OfferPaymentDefault({
  status,
  offer,
  hasApprovedOrder,
  hasPaidOrder,
  recalcInProgress,
  recalculateHandler,
  isOfferRecalcLoading,
}: TOfferPayment) {
  const { price, id: offerId } = offer

  const [approveOffer] = useApproveOfferMutation()
  const { uid, orderId } = useAppSelector(newAppealState)
  const { editAppealLoading, appealStatus } = useAppSelector(stateCurrentAppeal)
  const { setIsPullingStopped } = useActions()

  const { stage, createdDate, expireDate, isOfferActive, isDeclined } =
    useOfferPriceBlock(offer, appealStatus, status, hasApprovedOrder)

  // для КП, ещё не выбранного к оплате, блок виден, пока по нему не создан
  // оплаченный заказ, либо пока это отправленное КП не проиграло другому
  // одобренному предложению по заявке
  const isDefaultPaymentInfoVisible =
    (createdDate && !hasPaidOrder) || (status === 'SENT' && !hasApprovedOrder)

  const isAppealOffersLoading = editAppealLoading.appealOffers

  const approveOfferHandler = () => {
    const body = {
      uid,
      orderId,
      offerId,
    }

    approveOffer(body).then(() => {
      setIsPullingStopped(false)
    })
  }

  return (
    <div className={style.payment}>
      <span className='h2'>Оплата</span>

      {isAppealOffersLoading && <LoaderInCentalPosition />}
      <div
        className={classNames(
          style.paymentInf,
          isAppealOffersLoading ? style.hidden : '',
        )}
      >
        {isDefaultPaymentInfoVisible && (
          <div className={style.paymentInf}>
            {createdDate && !hasApprovedOrder && (
              <OfferDatesBlock
                createdDate={createdDate}
                expireDate={expireDate}
                isOfferActive={isOfferActive}
                stage={stage}
              />
            )}

            {isOfferRecalcLoading && (
              <LoaderInCentalPosition className={style.recalcLoader} />
            )}

            {!isOfferRecalcLoading && (
              <OfferPaymentDefaultInf
                offer={offer}
                isDeclined={isDeclined}
                isOfferActive={isOfferActive}
                hasApprovedOrder={hasApprovedOrder}
                recalculateHandler={() => recalculateHandler(offerId)}
                approveOfferHandler={approveOfferHandler}
                status={status}
                recalcInProgress={recalcInProgress}
                appealStatus={appealStatus}
              />
            )}
          </div>
        )}

        {isDeclined && (
          <div className={style.declined}>
            <span className='default-text'>Не оплачено</span>
            {price && (
              <div className={style.price}>
                <span className='default-text'>Итого</span>
                <span className='h2'>{formatPriceInRubles(price)}</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
